// TotalSummaryStyle.ts

export const totalSummaryMerges = [
  { row: 0, col: 0, rowspan: 1, colspan: 5 }, // Merge A1:E1
  { row: 2, col: 21, rowspan: 3, colspan: 1 }, // Merge V3:V5
  { row: 3, col: 0, rowspan: 1, colspan: 4 }, // Merge A4:D4
  { row: 4, col: 0, rowspan: 1, colspan: 4 }, // Merge A5:D5
  { row: 5, col: 0, rowspan: 1, colspan: 4 }, // Merge A6:D6
  { row: 6, col: 0, rowspan: 1, colspan: 4 }, // Merge A7:D7
  { row: 7, col: 0, rowspan: 1, colspan: 3 }, // Merge A8:C8
  { row: 8, col: 0, rowspan: 1, colspan: 3 }, // Merge A9:C9
  { row: 9, col: 0, rowspan: 1, colspan: 3 }, // Merge A10:C10
  { row: 10, col: 0, rowspan: 1, colspan: 3 }, // Merge A11:C11
  { row: 11, col: 0, rowspan: 1, colspan: 3 }, // Merge A12:C12
  { row: 12, col: 0, rowspan: 1, colspan: 3 }, // Merge A13:C13
];

export const totalSummaryColWidths = (index: number): number => {
  if (index === 4) return 60;
  return 100;
};

export function getTotalSummaryCellClassNames(row: number, col: number): string[] {
  const classNames: string[] = [];
  // Dark grey from A17 to AT300
  if (row >= 16 && row < 300 && col >= 0 && col <= 45) {
    classNames.push('grey-bg');
  }
  // W1:AT300 is row 0 to 299, col 22 to 45
  if (row >= 0 && row < 300 && col >= 22 && col <= 45) {
    classNames.push('grey-bg');
  }
  // A16:V16 is row 15, col 0 to 21
  if (row === 15 && col >= 0 && col <= 21) {
    classNames.push('white-bg');
  }
  // A1 should be bold
  if (row === 0 && col === 0) {
    classNames.push('bold');
  }
  // A4 should be bold, center, middle
  if (row === 3 && col === 0) {
    classNames.push('bold', 'center-middle');
  }
  // A3:V5 should be bold and have 2px bold border (was A4:V6)
  if (row >= 2 && row <= 4 && col >= 0 && col <= 21) {
    classNames.push('bold', 'bold-border');
  }
  // B5 (row 4, col 1): bold and center
  if (row === 4 && col === 1) {
    classNames.push('bold', 'htCenter');
  }
  // A5 (row 4, col 0): bold and center
  if (row === 4 && col === 0) {
    classNames.push('bold', 'htCenter');
  }
  // A7 (row 6, col 0): bold
  if (row === 6 && col === 0) {
    classNames.push('bold');
  }
  // E3, E4, E5 (row 2, 3, 4, col 4): center text
  if ((row === 2 || row === 3 || row === 4) && col === 4) {
    classNames.push('htCenter');
  }
  // V3 (row 2, col 21): center text
  if (row === 2 && col === 21) {
    classNames.push('htCenter');
  }
  // F5 to U5 (row 4, col 5-20): numeric, 3 decimals
  if (row === 4 && col >= 5 && col <= 20) {
    classNames.push('numeric-3dp');
  }
  return classNames;
} 